const React = window.React ?? null;

export default class VimeoButton extends React.Component {

    constructor(props) {
        super(props);
    }

    get data() {
        return this.props.data;
    }

    get vimeoData() {
        return this.props.vimeoData;
    }

    hasAnalyticsConsent() {
        return (typeof Cookiebot !== 'undefined') ? Cookiebot.consent?.statistics : true;
    }

    onButtonClick = (event) => {
        if (!event) {
            return;
        }
        
        event.preventDefault();

        if ((this.data.settings.button_on_click_active ?? null == 'yes') && window.dataLayer && this.hasAnalyticsConsent()) {
            const analyticsData = {
                id: this.data.node,
                label: (this.data.settings.analytics_label) ? this.data.settings.analytics_label : this.vimeoData.title ?? `Vimeo ID: ${this.data.settings.video_id}`,
                pageUrl: location.href
            };

            window.dataLayer.push({
                event: 'vimeoModalToggleButtonClick',
                ...analyticsData
            });
        }
    }

    render() {
        if (!this.vimeoData) {
            return;
        }

        return (
            <a
                className={`btn ${this.data.settings.button_style ?? 'btn-primary'} vimeo-button ${this.data.settings.button_classes ?? ''}`}
                href="#"
                title="Click here to watch the video."
                aria-label={this.data.settings.button_label}
                data-lum-vimeo-card-modal={this.data.settings.modal_id} 
                role="button"
                onClick={this.onButtonClick}
                tabIndex="0"
            >
                {this.data.settings.button_label}
            </a>
        );
    }
}